import CartItem from './CartItem';
import { SERVICE_CATEGORIES } from '../../../adlevo-vue/appConfiguration';
import { __loco, getCurrency } from '../../../utils/localization';
import { getUserCurrency } from '../../../utils/siteSettings';
import { parseDateInDD_MM_YYYY, parseDateInYYY_MM_DD } from '../../../adlevo-vue/utils/dateFormator';
import appApi from '../../../utils/appApi';

export default class HotelRoomTypeCartItem extends CartItem  {

	/**
	 * Set Room Type Data
	 * @param {Object} data - Hotel and Room Type Data
	 * @param {string} data.id - Hotel Id
	 * @param {string} data.hotelName - Hotel Title
	 * @param {Array} data.rooms - Rooms
	 * @param {String} data.currency_type - Currency
	 */
	constructor(data) {
		super(SERVICE_CATEGORIES.HOTELS);
		this.id = Number(data.id);
		this.hotelName = data.hotelName;
		this.currency_type = data.currency_type
		this.rooms = data.rooms;
	}

	/**
	 * @param {number} hotelId
	 * @return Boolean
	 */
	isMatchedByHotelId(hotelId) {
		return hotelId === this.hotelId;
	}

	getCurrencyType() {
		return this.currency_type
	}

	/** @override
	 * * @param {CartItem} cartItem
	 * * @return Boolean
	 */
	isMatched(cartItem) {
		return (
			Number(cartItem.id) === this.id &&
			cartItem.type === this.type
		);
	}

	setRooms(rooms){
		this.rooms = rooms;
	}

	/** @override
	 *	@param {HotelRoomTypeCartItem} hotelRoomTypeCartItem
	 *	@return null
	*/
	updateData(hotelRoomTypeCartItem){
		// Note: if this is not working,it means that thon is not updating its room type as index it have
		const updatedRooms = hotelRoomTypeCartItem.rooms;
		hotelRoomTypeCartItem.rooms.forEach(updatedRoom => {
			const roomIndex = this.rooms.findIndex(room => room.roomTypeId === updatedRoom.roomTypeId);
			if(roomIndex !== -1){
				this.rooms[roomIndex] = updatedRooms[0];
			}else {
				this.rooms.push(...updatedRooms);
			}
		});
		this.id = Number(hotelRoomTypeCartItem.id);
		this.hotelName = hotelRoomTypeCartItem.hotelName;
		this.currency_type = hotelRoomTypeCartItem.currency_type
	}

	getTotal() {
		return this.rooms.reduce((total, roomType) => {
			total += this.calculateRoomTotal(roomType);
			return total;
		}, 0).toFixed(2);
	}

	/** @override
	 *	@return string
	 */
	getTitle() {
		return this.hotelName;
	}

	/** @override
	 *	@return string|null
	 */
	getImageUrl() {
		return null;
	}

	/** @override
	 *	@return HTMLElement
	 */
	getHtmlCard() {
		const currency = this.getCurrencyType();
		const defaultCurrency = getUserCurrency();
		const element = document.createElement('div');
		element.className = 'cartItem';
		element.id = 'cart-item-' + this.type + '-' + this.id;
		element.innerHTML = `
				<div class="cartItemContainer light-theme">
					<div class="row">
						<div class="col-12">
							<h5 class="subtitle-2 font-weight-medium secondary-text">${this.getTitle()}</h5>
						</div>
					</div>
					
					${this.rooms.map(room => {
						const roomTypeImage = room.images && room.images.length ? room.images[0] : null;
						return `<div class="row justify-content-between my-2">
							<div class="col-12">
								<p class="cartTourData body-2 secondary-text">Room: ${room.title}</p>
							</div>
							<div class="col-6">
								<p class="cartTourData caption secondary-text">From: ${parseDateInDD_MM_YYYY(room.checkInDate)}</p>
								<p class="cartTourData caption secondary-text">To: ${parseDateInDD_MM_YYYY(room.checkOutDate)}</p>
								<div>
									${room.availability.map((roomAvailabilityData, index) => {
										
										return `
										<p class="cartTourData caption secondary-text mt-2">Room ${index + 1}</p>
										<p class="cartTourData caption secondary-text">${roomAvailabilityData.num_of_adults} x Adults</p>
										<p class="cartTourData caption secondary-text">${roomAvailabilityData.num_of_children} x Children</p>
										<p class="cartTourData caption secondary-text">Price: ${currency ?  currency : defaultCurrency}  ${room.price}</p>
										`
									}).join('')}
								</div>
							</div>
							<div class="col-6">
								<div class="row justify-content-end">
								<img class="cartItemImage" alt="cart item image" src="${roomTypeImage}"></div>
							</div>
						</div>
						<div class="row align-items-center mt-2 mb-3">
						<div class="col-6">
							<div class="row align-items-center">
								<div class="col-auto pl-0 pr-0">
									<span>|</span>
								</div>
								<div class="col-auto">
									<a class="cart__item_left-footer__button cart-room-type-item-remove-btn" data-type="${this.type}" data-id="${this.id}" data-room-type-id="${room.roomTypeId}">${__loco('Remove')}</a>
								</div>
							</div>
						</div>
						<div class="col-6"><div class="row justify-content-end align-items-center">
							<div class="col-12">
								<p class="cart__item_price-wrapper body-2">${currency ?  currency : defaultCurrency} <span class="cart__item_price subtitle-2">${this.calculateRoomTotal(room).toFixed(2)}</span></p>
							</div>
						</div>
						</div>
						</div>
					</div>`
					}).join('')}
		`
		return element;
	}

	/** @override Get CartItem Type
	 *	@return string
	 */
	getType() {
		return this.type;
	}

	/** @override Get CartItem Id
	 *	@return Number|String
	 */
	getId() {
		return Number(this.id);
	}

	/** @override Get Checkout Request Payload
	 *	@return Object
	 */
	toRequestPayloadForValidateItems() {
		const rooms = []
		this.rooms.forEach(room => {
			room.availability.forEach(roomAvailability => {
			rooms.push({
				"hotel_id": this.id,
				"start_date": parseDateInYYY_MM_DD(room.checkInDate),
				"end_date": parseDateInYYY_MM_DD(room.checkOutDate),
				"num_of_adults": roomAvailability.num_of_adults,
				"num_of_children": roomAvailability.num_of_children,
				"num_of_allotment": roomAvailability.num_of_allotment,
				"children_ages": roomAvailability.children_ages,
				"room_type_id": Number(room.roomTypeId),
				"channel_manager_id": Number(room.channel_manager_id),
				"room_code": room.room_code ? room.room_code : null,
				"reserved_product_code": room.reserved_product_code ? room.reserved_product_code : null,
				"rate_plan_code": room.rate_plan_code ? room.rate_plan_code : null,
				"rate_plan_id": room.rate_plan_id ? room.rate_plan_id : 0,
				"hotel_code": room.hotel_code ? room.hotel_code : null,
				"currency_type": room.currency_type ? room.currency_type : getCurrency(),
				"price": room.price,
				"total_price": room.total_price,
			})
			})
		})

		return rooms;
	}

	calculateRoomTotal(room) {
		return room.availability.reduce((total) => {
			// total += room.total_price;
			return room.total_price;
		}, 0)
	}

	getRooms() {
		return this.rooms;
	}

	async validateCartItem() {
		try {
			const requestPayload = [];
			this.rooms.forEach(room => {
				// Note: room.availability comes with list of room and with num of adult child and allotments
				room.availability.forEach(roomAvailabilityData => {
					requestPayload.push({
						"hotel_id": this.id,
						"start_date": parseDateInYYY_MM_DD(room.checkInDate),
						"end_date": parseDateInYYY_MM_DD(room.checkOutDate),
						"num_of_adults": roomAvailabilityData.num_of_adults,
						"num_of_children": roomAvailabilityData.num_of_children,
						"num_of_allotment": roomAvailabilityData.num_of_allotment,
						"room_type_id": Number(room.roomTypeId),
						"channel_manager_id": Number(room.channel_manager_id),
						"room_code": room.room_code ? room.room_code : null,
						"reserved_product_code": room.reserved_product_code ? room.reserved_product_code : null,
						"rate_plan_code": room.rate_plan_code ? room.rate_plan_code : null,
						"rate_plan_id": room.rate_plan_id ? room.rate_plan_id : 0,
						"hotel_code": room.hotel_code ? room.hotel_code : null,
						"currency_type": room.currency_type,
						"price": room.price,
						"total_price": room.total_price
					});
				})
			});

			const response = await appApi.public.tour.basket.validateHotelItem(requestPayload);
			const rooms = response.data || [];
			rooms.forEach(room => {
				if(!room.status){
					throw new Error('room is not available');
				}
			})
		}catch (e) {
			throw new Error(e)
		}
	}
}